// src/redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Utiliza localStorage
import authReducer from './slices/authSlice';
import { combineReducers } from 'redux';

// Configuración de redux-persist
const persistConfig = {
  key: 'root',
  storage,
};

// Combina los reducers si tienes más de uno
const rootReducer = combineReducers({
  auth: authReducer,
});

// Aplica persistencia al reducer principal
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configura el store con el reducer persistido
const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

// Tipos para el estado global y el dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
